import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsu-property-type',
  templateUrl: './property-type.component.html',
  styleUrls: ['./property-type.component.scss']
})
export class PropertyTypeComponent implements OnInit {
  productItems: any;
  constructor(private httpClient: HttpClient) { }

  ngOnInit() {
    this.getProducts();
  }

  private getProducts() {
    this.httpClient.get("assets/json/categories.json").subscribe(data => {
      this.productItems = data;
      console.log("Categories", data);
    });
  }
}
